let parseSchemaWithoutLocation = false;

/**
 * When enabled, the schema SDL is parsed with graphql-js `parse(s, { noLocation: true })` instead
 * of graphql-tag's `gql`. This avoids attaching (and then deleting) `loc` on every AST node and
 * skips graphql-tag's document cache, which significantly reduces the retained heap size.
 *
 * The parsed schema is cached on first use, so this must be set before the schema is first loaded.
 */
export function setParseSchemaWithoutLocation(enabled: boolean): void {
    parseSchemaWithoutLocation = enabled;
}

export function getParseSchemaWithoutLocation(): boolean {
    return parseSchemaWithoutLocation;
}
